/* 2026-10-20 (user): OMC-style collection pages of 10 product rows.
   Desktop (3 cols): 26 products = 10 rows; rows 2 and 8 = a 2-cell large product block + 1 product. Mobile (2 cols): 16 products = 10 rows incl. the 2 full-width block rows (rows 2 and 8) - user 2026-10-20.
   The server paginates by 26 (one desktop page). Mobile pages (16) are cut from those client-side and linked as ?mp=N.
   "See more" appends the next 10 rows (fetching server pages as needed); each 10-row block is tagged data-blk so
   usa-collection-breaks.js can put large blocks on that block's rows 2 and 8. Swipe-in animation is untouched (usa-draft-motion.js watches the grid).
   Remembers how far the shopper got so Back from a product page restores the same rows and scroll position. */
(()=>{
const MQ=matchMedia('(max-width:989px)');
const K=()=>{const d=st&&st.root.dataset;return MQ.matches?(+(d&&d.km)||16):(+(d&&d.kd)||26)};/* per page: data-km / data-kd from the snippet (search = 20 / 30, no large blocks) */
const HIDE='usa-pg-hide';
let st=null;

function items(grid){return [...grid.querySelectorAll(':scope>li.js-pagination__item')]}
function emit(){document.dispatchEvent(new CustomEvent('usa:grid-change'))}
function srvURL(p){const u=new URL(st.href,location.href);u.searchParams.set('page',p);u.searchParams.delete('mp');return u}
/* 2026-10-21 (user: "few second pause when going to next page"): server pages are cached (the first one seeded from the
   page itself), the next page is prefetched when idle and any page is prefetched on pointerdown/touchstart of its link. */
const CACHE=new Map();
function build(html){const t=document.createElement('template');t.innerHTML=html.join('');return [...t.content.children].map(li=>{li.classList.remove('usa-pg-x','usa-collection-enter','is-visible','usa-no-enter');li.classList.add(HIDE);li.removeAttribute('data-blk');return li})}
function load(p){
  if(!CACHE.has(p)){
    const u=srvURL(p);u.searchParams.set('section_id',st.section);
    CACHE.set(p,fetch(u,{credentials:'same-origin'}).then(r=>{if(!r.ok)throw new Error('pager '+r.status);return r.text()}).then(txt=>{
      const t=document.createElement('template');t.innerHTML=txt;const g=t.content.getElementById('product-grid');
      return g?items(g).map(li=>li.outerHTML):[]}).catch(e=>{CACHE.delete(p);throw e}));
  }
  return CACHE.get(p);
}
async function fetchPage(p){return build(await load(p))}
function prefetch(p){if(st&&p>=1&&p<=st.pages)load(p).catch(()=>{})}
function pagesFor(v){const k=K(),off=(v-1)*k,p=Math.floor(off/st.per)+1;return off%st.per+k>st.per?[p,p+1]:[p]}
async function fill(need){
  while(st.buf.length<need&&st.nextP<=st.pages){
    const p=st.nextP++;const got=await fetchPage(p);
    st.grid.append(...got);st.buf.push(...got);
  }
}
async function more(){
  if(st.busy)return;st.busy=true;st.root.classList.add('is-loading');
  try{
    const k=K();await fill(st.shown+k);
    const next=st.buf.slice(st.shown,st.shown+k);
    next.forEach(li=>{li.dataset.blk=st.nb;li.classList.remove(HIDE,'usa-pg-x')});
    if(next.length){st.shown+=next.length;st.nb++}
    draw();emit();
    window.stickersReinit?.();window.renderSelects?.();
  }catch(e){console.warn(e)}finally{st.busy=false;st.root.classList.remove('is-loading')}
}
async function go(v,scroll=true){
  const k=K();v=Math.max(1,Math.min(v,Math.ceil(st.total/k)||1));
  const off=(v-1)*k,p=Math.floor(off/st.per)+1,skip=off%st.per;
  /* fetch first (current products stay on screen), then swap in one go */
  let list=[],np=p;
  try{list=(await fetchPage(p)).slice(skip);np=p+1;while(list.length<k&&np<=st.pages){list=list.concat(await fetchPage(np));np++}}catch(e){console.warn(e)}
  if(!list.length&&st.total>0){location.assign(srvURL(p));return}   /* fetch failed: fall back to the real server page rather than an empty grid */
  {const u=new URL(location.href);u.searchParams.delete('page');if(v>1)u.searchParams.set('mp',v);else u.searchParams.delete('mp');history.replaceState(history.state,'',u)}   /* URL first: the large-block picker keys its products off the page number */
  items(st.grid).forEach(li=>li.remove());st.grid.querySelectorAll(':scope>.usa-cbreak').forEach(b=>b.remove());
  st.off=off;st.buf=list;st.shown=0;st.nb=0;st.nextP=np;
  st.grid.append(...list);
  await more();
  st.grid.style.opacity='';
  if(scroll)scrollTo({top:0,behavior:'instant'});   /* 2026-10-21 (user): next / previous / page numbers go to the top of the page */
  /* only the products on screen after the jump appear without the slide-in; the rest keep it */
  st.grid.querySelectorAll(':scope>li').forEach(li=>{const r=li.getBoundingClientRect();if(r.height&&r.top<innerHeight&&r.bottom>0)li.classList.add('usa-collection-enter','is-visible','usa-no-enter')});
  idle(()=>prefetch(st.nextP));
}
const idle=f=>(window.requestIdleCallback||setTimeout)(f,{timeout:2500});
function href(n){
  if(!MQ.matches){const u=srvURL(n);if(n===1)u.searchParams.delete('page');return u.pathname+u.search}
  const u=new URL(location.href);u.searchParams.delete('page');if(n>1)u.searchParams.set('mp',n);else u.searchParams.delete('mp');return u.pathname+u.search;
}
function draw(){
  const k=K(),N=Math.ceil(st.total/k),first=Math.floor(st.off/k)+1,cur=Math.max(first,Math.floor((st.off+Math.max(st.shown,1)-1)/k)+1);
  const meta=st.root.querySelector('.usa-pager__meta');
  let mo=meta.querySelector('[data-usa-more]');
  const left=st.off+st.shown<st.total;
  if(left&&!mo){mo=document.createElement('a');mo.className='usa-pager__more';mo.dataset.usaMore='';mo.innerHTML='See more<span class="visually-hidden"> products</span>';meta.append(mo)}
  if(mo){mo.hidden=!left;mo.href=href(cur+1)}
  let nav=st.root.querySelector('.usa-pager__nav');
  if(N<=1){nav?.remove();return}
  if(!nav){nav=document.createElement('nav');nav.className='usa-pager__nav';nav.setAttribute('aria-label','Pagination');st.root.append(nav)}
  const set=new Set([1,N]);
  const lo=cur<=2?1:cur>=N-1?N-2:cur-1;for(let i=lo;i<lo+3;i++)if(i>=1&&i<=N)set.add(i);
  const list=[...set].sort((a,b)=>a-b);
  let h='';
  if(first>1)h+=`<a class="usa-pager__arrow usa-pager__arrow--prev" href="${href(first-1)}" data-go="${first-1}" aria-label="Previous page"><svg viewBox="0 0 19 32" aria-hidden="true"><path d="M.2 16 16.2 0 19 2.8 5.8 16 19 29.2 16.2 32z"/></svg></a>`;
  h+='<ul class="usa-pager__list" role="list">';
  list.forEach((n,i)=>{
    if(i&&n-list[i-1]>1)h+='<li><span class="usa-pager__gap">…</span></li>';
    h+=n===cur?`<li><span class="usa-pager__link usa-pager__link--current" aria-current="page">${n}</span></li>`:`<li><a class="usa-pager__link" href="${href(n)}" data-go="${n}">${n}</a></li>`;
  });
  h+='</ul>';
  if(cur<N)h+=`<a class="usa-pager__arrow usa-pager__arrow--next" href="${href(cur+1)}" data-go="${cur+1}" aria-label="Next page"><span class="usa-pager__next-label">Next page</span><svg viewBox="0 0 19 32" aria-hidden="true"><path d="M18.8 16 2.8 32 0 29.2 13.2 16 0 2.8 2.8 0z"/></svg></a>`;
  nav.innerHTML=h;
}
const KEY=()=>'usa-pager:'+location.pathname+location.search;
function remember(){if(!st)return;try{sessionStorage.setItem(KEY(),JSON.stringify({off:st.off,shown:st.shown,k:K(),y:scrollY,t:Date.now()}))}catch(e){}}

async function init(){
  const root=document.querySelector('[data-usa-pager]'),grid=document.getElementById('product-grid');
  if(!root||!grid||root.dataset.ready)return;root.dataset.ready='1';
  const per=+root.dataset.per||26,page=+root.dataset.page||1;
  st={root,grid,per,total:+root.dataset.total||0,pages:+root.dataset.pages||1,section:root.dataset.section,href:root.dataset.href||location.href,
      off:(page-1)*per,buf:items(grid),shown:0,nb:0,nextP:page+1,busy:false};
  CACHE.set(page,Promise.resolve(st.buf.map(li=>li.outerHTML)));   /* this server page is already here - no refetch when building mobile pages from it */
  st.buf.forEach(li=>{li.classList.remove('usa-pg-x');li.classList.add(HIDE)});
  const mp=+(new URL(location.href).searchParams.get('mp')||0);
  let saved=null;try{saved=JSON.parse(sessionStorage.getItem(KEY())||'null')}catch(e){}
  const nav=performance.getEntriesByType('navigation')[0]?.type;
  const back=nav==='back_forward'||(()=>{try{const r=new URL(document.referrer);return r.origin===location.origin&&r.pathname.includes('/products/')}catch(e){return false}})();
  if(!(back&&saved&&Date.now()-saved.t<3600000&&saved.k===K()))saved=null;
  if(saved)history.scrollRestoration='manual';
  if(mp>1)await go(mp,false);else await more();
  if(saved){
    while(st.shown<saved.shown&&st.off+st.shown<st.total){const s=st.shown;await more();if(st.shown===s)break}
    requestAnimationFrame(()=>scrollTo({top:saved.y,behavior:'instant'}));
  }
  grid.style.opacity='';
  idle(()=>prefetch(st.nextP));
  /* desktop page numbers are real links: let Chrome pre-render the page on hover so it opens instantly */
  if(!MQ.matches&&HTMLScriptElement.supports&&HTMLScriptElement.supports('speculationrules')&&!document.getElementById('usa-pager-spec')){
    const sr=document.createElement('script');sr.type='speculationrules';sr.id='usa-pager-spec';
    sr.textContent=JSON.stringify({prerender:[{where:{selector_matches:'.usa-pager a[href]'},eagerness:'moderate'}]});document.head.append(sr);
  }
}

const warm=e=>{if(!st||!MQ.matches)return;const a=e.target.closest&&e.target.closest('a');if(!a||!st.root.contains(a))return;if(a.dataset.go)pagesFor(+a.dataset.go).forEach(prefetch);else if(a.matches('[data-usa-more]'))prefetch(st.nextP)};
document.addEventListener('pointerdown',warm,{passive:true,capture:true});document.addEventListener('touchstart',warm,{passive:true,capture:true});
document.addEventListener('click',e=>{
  if(!st)return;
  const a=e.target.closest('a');if(!a)return;
  if(a.matches('[data-usa-more]')&&st.root.contains(a)){e.preventDefault();more();return}
  if(a.dataset.go&&st.root.contains(a)&&MQ.matches){e.preventDefault();go(+a.dataset.go);return}
  if(a.href&&a.href.includes('/products/')&&st.grid.contains(a))remember();
},true);
addEventListener('pagehide',remember);
const start=()=>{
  init();
  const c=document.getElementById('ProductGridContainer');
  if(c)new MutationObserver(()=>{const r=document.querySelector('[data-usa-pager]');if(r&&!r.dataset.ready)init()}).observe(c,{childList:true});
};
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',start,{once:true});else start();
})();
